<template>
  <div class="intro">
    <b-container>
      <p class="h6 font-weight-bolder text-left mb-3 text-center">
        2. When would you like to practice?
        <small class="text-muted d-block"
          >Set the time of day to work on your homework and organization skills.</small
        >
      </p>
      <div class="pt-3 m-auto">
        <notifications @formatTime="saveCurrentView"></notifications>
      </div>
    </b-container>
  </div>
</template>

<script>
import Notifications from '@/components/Notifications';

export default {
  components: {
    Notifications,
  },
  methods: {
    saveCurrentView({ timeDay, hour, minutes }) {
      if (timeDay && hour != null && minutes != null) {
        const hours = hour + ':' + minutes;
        this.$emit('stepData', { timeDay, hours });
      }
    },
  },
};
</script>
